import React, { useState } from 'react'
import { MultiSelect } from 'react-multi-select-component'
import FormTemplateCard from './formTemplateCard'
import { useNavigate } from 'react-router-dom'
import { useQuery } from '@apollo/client'
import { GET_FORM_TEMPLATE_DETAILS } from '../../../graphql/query'
// import { useHistory } from 'react-router-dom';

const CreateNewForm = () => {
  const options = [
    { label: 'Order Form', value: 'order' },
    { label: 'Registration Form', value: 'registration' },
    { label: 'Event Registration Form', value: 'eventRegistration' },
    { label: 'Payment Form', value: 'paymentForm' },
    { label: 'Application Form', value: 'application' },
    { label: 'File Upload Form', value: 'fileUpload' },
    { label: 'Booking Form', value: 'booking' },
    { label: 'Survey Form', value: 'survey' },
    { label: 'Consent Form', value: 'consent' },
    { label: 'Appointment Form', value: 'appointment' },
    { label: 'Contact Form', value: 'contact' },
    { label: 'Signup Form', value: 'signup' },
    { label: 'Voting Form', value: 'voting' }
  ]

  const [selectedTemplates, setSelectedTemplates] = useState<any>([])
  const navigate = useNavigate()
  const { loading, error, data } = useQuery(GET_FORM_TEMPLATE_DETAILS, {
    variables: {
      input: {
        category: localStorage.getItem('formType')
      }
    },
    context: {
      headers: {
        'access-control-allow-methods': 'Form-Builder'
      }
    }
  })
  // const history = useHistory();

  if (loading) {
    return <>Loading....</>
  }
  if (error) {
    console.log(error)
  }

  if (data) {
    console.log(data?.getFormTemplateDetails?.data)
  }

  const handleNavigate = () => {
    navigate('/automation/process-automation/form-builder')
  }

  return (
    <div className='card'>
      {/* begin::Header */}
      <div className='card-header row pt-3'>
        <div className='card-title col-4 align-items-start flex-row'>
          <span className='mt-1 text-hover-primary' onClick={handleNavigate}>
            <i className='bi bi-arrow-left' style={{ fontSize: '1.75rem' }}></i>
          </span>
          <div className='d-flex flex-column ms-7'>
            <span className='card-label fw-bolder fs-3 mb-1'>Select Form Template</span>
            <span className='text-muted mt-1 fw-bold fs-7'>
              Templates help you start building your own Form
            </span>
          </div>
        </div>
        {/* begin: Filter */}
        <form className='row col ms-2 mb-5'>
          {/* <div className='col'> */}
          {/* <label className='card-label fw-bolder fs-4'>Categories:</label> */}
          {/* MultiSelect dropdown for form templates */}
          {/* <MultiSelect
              options={options}
              value={selectedTemplates}
              onChange={setSelectedTemplates}
              labelledBy='Select Form Templates'
              className='w-400px'
            /> */}
          {/* </div> */}
        </form>
        {/* end: Filter */}
      </div>
      {/* end::Header */}

      {/* begin::Body */}
      <div className='card-body d-flex justify-content-start flex-wrap me-5'>
        {Array.isArray(data?.getFormTemplateDetails?.data) ? (
          data?.getFormTemplateDetails?.data?.map((template: any, index: number) => (
            <FormTemplateCard
              key={index}
              formName={template?.name}
              formDescription={template?.description}
              formImageLink={template?.imageUrl}
              formJson={template?.templateData}
              templateId={template?.id}
            />
          ))
        ) : (
          <p>No form templates available.</p>
        )}
      </div>
      {/* end::Body */}
    </div>
  )
}

export default CreateNewForm
